import { render } from "./VendorPaymentsIndexTable.vue?vue&type=template&id=4658f696"
import script from "./VendorPaymentsIndexTable.vue?vue&type=script&lang=js"
export * from "./VendorPaymentsIndexTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__